import { useCallback, useMemo } from 'react'
import { Formik, Form } from 'formik'
import { string, object, SchemaOf } from 'yup'
import moment from 'moment'

import { FormDatePicker } from '@collaborate-health/forms'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@collaborate-health/uikit'
import { UpdateQualificationVersionsRequest } from '@tabeeb/contracts/microservices/swagger-certificate-service'

const schema: SchemaOf<Pick<UpdateQualificationVersionsRequest, 'ExpirationDate'>> = object().shape({
  ExpirationDate: string()
    .optional()
    .nullable()
    .test('is-future-date', 'Expiration date must be in the future', (value) => {
      if (!value) {
        return true
      }

      return moment(value).isAfter(moment())
    }),
})

export interface EditQualificationExpirationDialogProps {
  open: boolean
  initial: string | null
  onClose: () => void
  onSubmit: (newDate?: string | null) => void
}

const EditQualificationExpirationDialog: React.FC<EditQualificationExpirationDialogProps> = ({
  open,
  initial,
  onClose,
  onSubmit,
}) => {
  const initialValues = useMemo<Pick<UpdateQualificationVersionsRequest, 'ExpirationDate'>>(
    () => ({
      ExpirationDate: initial || null,
    }),
    [initial]
  )

  const handleSubmit = useCallback(
    (values: Pick<UpdateQualificationVersionsRequest, 'ExpirationDate'>) => {
      onSubmit(values.ExpirationDate)
      onClose()
    },
    [onSubmit, onClose]
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <Formik enableReinitialize initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit}>
        {({ isValid, dirty }) => (
          <Form>
            <DialogTitle>Edit Expiration Date</DialogTitle>
            <DialogContent>
              <FormDatePicker name='ExpirationDate' label='Expiration Date' fullWidth disablePast />
            </DialogContent>
            <DialogActions>
              <Button color='primary' onClick={onClose}>
                Cancel
              </Button>
              <Button type='submit' variant='contained' color='primary' disabled={!isValid || !dirty}>
                Save
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default EditQualificationExpirationDialog

